export default "__VITE_ASSET__DLwpA02y__"